module.exports = __webpack_public_path__ + "static/media/fee_btech_2017_18.8ebd3cf2.pdf";